import {
  Component
} from '@angular/core';

import {
  RouterOutlet
} from '@angular/router';

import {
  SidebarComponent
} from '../sidebar/sidebar.component';


@Component({
  selector: 'app-admin-layout',

  standalone: true,

  imports: [
    RouterOutlet,
    SidebarComponent
  ],

  templateUrl: './admin-layout.component.html',

  styleUrls: [
    './admin-layout.component.css'
  ]
})
export class AdminLayoutComponent {

}
